import UseColumnsManager from './UseColumnsManager'

export default UseColumnsManager
